module.exports = __webpack_public_path__ + "4f8151e3808b5ba451b4321a73945eae.png";